import { LowerCasePipe, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxAmountPipe } from '@onyx/angular';
import { DateRangeCellComponent } from '../../../../../common/components/cells/date-range-cell/date-range-cell.component';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import { ColorHelper } from '../../../../../common/helpers/color.helper';
import { DriverSettlementMethod } from '../../enums/driver-settlement-method';
import type { Driver } from '../../interfaces/driver';

@Component({
  selector: 'app-driver-contract-cell',
  imports: [
    DateRangeCellComponent,
    TranslatePipe,
    LowerCasePipe,
    NgTemplateOutlet,
    OnyxAmountPipe,
  ],
  templateUrl: './driver-contract-cell.component.html',
  styleUrl: './driver-contract-cell.component.scss',
})
export class DriverContractCellComponent {
  public readonly employmentConditions = input.required<
    Driver['employmentConditions'] | null
  >();

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly DriverSettlementMethod = DriverSettlementMethod;

  protected cellColor = computed(() =>
    ColorHelper.getCellColor(
      this.employmentConditions()!.contractTerm?.to as unknown as string,
    ),
  );
}
